/**
 * Tiny holder so generation steps can lock the active project binder
 * without importing page entry modules (avoids app ↔ step cycles).
 */

let activeBinder = null;

export function setActiveProjectBinder(binder) {
  activeBinder = binder || null;
}

export function getActiveProjectBinder() {
  return activeBinder;
}

/** Lock after a task/job has been created with the current project. */
export function lockActiveProjectBinder(reason = 'locked') {
  if (activeBinder && typeof activeBinder.lock === 'function') {
    activeBinder.lock(reason);
  }
}
